import "./css_imports";

import React, { Fragment, Suspense } from "react";
import { Route, Switch } from "react-router-dom";

import { Container } from "./components/container";
import { PageLoader } from "./components/page_loader";
import { AppProvider } from "./core/app_provider";
import { lazyWithRetry } from "./core/lazy_with_retry";
import PortalPagesWrapper from "./offering/chunk_portal_page_wrapper";
import { portalRoutePaths } from "./offering/portal_paths";
import ChecksPage from "./pages/checks_page";
import { HomePage } from "./pages/home";
import { NotFoundPage } from "./pages/not_found";
import { PrivacyPage } from "./pages/privacy_page";
import { TermsPage } from "./pages/terms_page";
import { AnalyticsProvider } from "./lib/analytics/analytics";
import {
  FlexspaceAnalyticsProvider,
  ThePortalAnalyticsProvider,
  CMDashboardAnalyticsProvider,
} from "./core/app_tracker";
import { ErrorBoundary } from "./components/error_boundary";

const ManagerPagesWrapper = lazyWithRetry(
  () => import("./offering/chunk_fm_page_wrapper")
);

const OfferingsPagesWrapper = lazyWithRetry(
  () => import("./offering/chunk_offerings_page_wrapper")
);

function App() {
  return (
    <Fragment>
      <Suspense fallback={<PageLoader />}>
        <AppProvider>
          <AnalyticsProvider>
            <Container>
              <ErrorBoundary>
                <Switch>
                  <Route path="/offerings">
                    <FlexspaceAnalyticsProvider>
                      <OfferingsPagesWrapper />
                    </FlexspaceAnalyticsProvider>
                  </Route>
                  <Route path={portalRoutePaths}>
                    <ThePortalAnalyticsProvider>
                      <PortalPagesWrapper />
                    </ThePortalAnalyticsProvider>
                  </Route>
                  <Route path="/checks">
                    <ChecksPage />
                  </Route>
                  <Route path="/manage">
                    <CMDashboardAnalyticsProvider>
                      <ManagerPagesWrapper />
                    </CMDashboardAnalyticsProvider>
                  </Route>
                  <Route exact path="/dashboard">
                    <HomePage />
                  </Route>
                  <Route exact path="/">
                    <HomePage />
                  </Route>
                  <Route exact path="/privacy">
                    <PrivacyPage />
                  </Route>
                  <Route exact path="/terms">
                    <TermsPage />
                  </Route>
                  <Route component={NotFoundPage} />
                </Switch>
              </ErrorBoundary>
            </Container>
          </AnalyticsProvider>
        </AppProvider>
      </Suspense>
    </Fragment>
  );
}

export default App;
